// import React, { useContext, useState, useEffect, useCallback, useMemo } from 'react'
import React, { useContext, useState, useEffect, useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Contract } from 'web3-eth-contract'
import { Text } from 'rebass'
import Row, { AutoRow } from '../../components/Row'
import Loader from '../../components/Loader'
import Value from '../../components/Value/OnlyValue'
import { NFTTYPE, SUPPORTTYPE } from '../../constants/bakery/nft'
import { ButtonLight, ButtonConfirmed } from '../../components/Button'
import { useActiveWeb3React } from '../../hooks'
import { useWalletModalToggle } from '../../state/application/hooks'
import { NavLink } from 'react-router-dom'
import { provider } from 'web3-core'
// import useApprove from '../../hooks/bakery/useApprove'
import { userTokenAddress } from '../../userType/userTokenAddress'
import { userTokenDecimals } from '../../userType/userTokenDecimals'
import { getGameNftMasterContract } from '../../userType/gameNftMasterContract'
import { getContract, getAllowance } from '../../utils/bakery/erc20'
// import { getContract } from '../../utils/bakery/erc20'
import useYam from '../../hooks/bakery/useYam'
import BigNumber from 'bignumber.js'
import WinPrizeModal from './WinPrizeModal'
import NotWinPrizeModal from './NotWinPrizeModal'
import useModal from '../../hooks/bakery/useModal'

// import useAllowance from '../../hooks/bakery/useAllowance'
import {
  useBnbBalance,
  useSoccerBalance,
  usePokerBalance,
  useCarBalance,
  useDoggyBalance,
  useBarkBalance,
  useRacaBalance,
  useBusdBalance,
  useBakeBalance
} from '../../hooks/useAllTokenBalance'

import { 
  approve, 
  getGaAddress,
  getDoggyAddress,
  matrixPlusBoxContractGetWaitingToMintLength,
  matrixPlusBoxContractGetPayTokenPrices,
  doggyEquipmentGetEnableEquipmentIds
} from '../../sushi/utils'

import { 
  userLuckyTime,
  userLuckyResult,
  getPayTokenInfos,
  getLockTokenInfos
} from '../../sushi/bakeMuskMixer'

import { 
  getPayTokenInfos as getMuskUsmLandPayTokenInfos,
  getStartBlock,
  getEndBlock
} from '../../sushi/muskUsmLand'

import {
  getPayTokenInfos as sellPayTokenInfo,
  getSellInfo
} from '../../sushi/sellNFTs'

import useSynthesis from '../../hooks/nft/useSynthesis'
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { compare } from '../../utils/func'
import useNodeBlock from '../../hooks/ido/useNodeBlock'

const FormWrapper = styled.div<{ pad?: string }>`
    background: ${({ theme }) => theme.bsBg6};
    box-shadow: 0px 2px 10px ${({ theme }) => (theme.darkMode ? 'transparent' : 'rgba(171, 133, 115, 0.16)')};
    border-radius: 20px;
    width: 432px;
    max-height: 305px;
    /* min-height: 152px; */
    padding: ${({ pad }) => (pad ? pad : '19px 21px 12px')};
    ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 16px 20px 20px;
    width: 90%;
    margin: 30px auto;
    `};
`
const AttachRow = styled.div<{ marginBottom?: number }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme }) => theme.bsText3};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : 0)}px;
    .label {
        margin-left: 3px;
        font-size: 13px;
        font-family: no;
        color: ${({ theme }) => theme.bsText3};
    }
`
const AttachBtnRow = styled(AttachRow)`
    flex-wrap: wrap;
    width: calc(100% + 10px);
    margin-left: -5px;
    flex-wrap: wrap;
    ${({ theme }) => theme.mediaWidth.upToExtraSmall`
        flex-direction: column;
    `};
`

const ButtonInfo = styled.div<{ width?: number }>`
    width: ${({ width }) => (width ? width + 'px' : '186px')};
    flex: 1 1 auto;
    margin: 0px 5px 16px;

    .btn{
        margin-bottom: 8px;
    }
`

const ValueItem = styled.div`
    display: flex;
    align-items: center;
`

const MyDishes = styled(NavLink)<{width?: string}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width ? width : '100%'};
  border: 1px solid ${({ theme }) => theme.bsText7};
  border-radius: 10px;
  color: ${({ theme }) => theme.primary1};
  font-family: Baloo Da;
  height: 32px;
  text-decoration: none;
  margin-bottom: 10px;
`
const Website = styled.a<{width?: string}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width ? width : '100%'};
  border: 1px solid ${({ theme }) => theme.bsText7};
  border-radius: 10px;
  color: ${({ theme }) => theme.primary1};
  font-family: Baloo Da;
  height: 32px;
  text-decoration: none;
  margin-bottom: 10px;
`

export default function ExchangeNft({ type }: { type: string; }) {
  // 当前区块
  const curNum = useNodeBlock()
  const [curBlock, setCurBlock] = useState(curNum)
  useEffect(() => {
    setCurBlock(+curNum)
  }, [curNum])
  const [startBlock, setStartBlock] = useState(0)
  const [endBlock, setEndBlock] = useState(0)

  const theme = useContext(ThemeContext)
  const { account, library } = useActiveWeb3React()
  const sushi = useYam()
  const ethereum = library?.provider
  const masterContract: Contract = getGameNftMasterContract(type, sushi)
  const toggleWalletModal = useWalletModalToggle()

  let boxContentTitle
  let boxContentValue
  let currentValueTitle
  let exchangeToken: Array<any> = []
  let tokenAmountAryFormat: Array<any> = []

  let getToken
  let myUrl
  let urls
  let nftToken: any
  switch (type) {
    case NFTTYPE.GIFTBOX:
      boxContentTitle = 'Gift: '
      boxContentValue = '1500TLM + 20Alice + 10Toko + 50TCT + 50PET'
      currentValueTitle = 'Current Values of Tokens in each Box : '
      exchangeToken = [
        SUPPORTTYPE.BNB,
        SUPPORTTYPE.SOCCER,
        SUPPORTTYPE.POKER,
        SUPPORTTYPE.CAR
      ]
      getToken = 'BSC Gift Box NFT'
      myUrl = '/my-giftbox'
      break
    case NFTTYPE.GAMEBOX:
      boxContentTitle = 'Tokens in each Box: '
      boxContentValue = 'TLM*1500 + ALICE*20 + PET*20'
      currentValueTitle = 'Current Values of Tokens in each Box : '
      exchangeToken = [
        SUPPORTTYPE.SOCCER,
        SUPPORTTYPE.POKER
      ]
      getToken = 'BSC Game Box NFT'
      myUrl = '/my-game-box'
      break
    case NFTTYPE.DOGGIES:
      exchangeToken = [
        SUPPORTTYPE.DOGGY
      ]
      getToken = 'Crypto Doggy NFT'
      myUrl = '/myArtwork/doggies'
      urls = [{title: 'Marketplace', isWeb: true, next: '/exchange/doggynft'}, {title: 'Website', isWeb: false, next: 'https://www.cryptodoggies.io/'}, {title: 'Buy $DOGGY', isWeb: true, next: `${'/swap?outputCurrency=' + getDoggyAddress(sushi)}`}, {title: 'Play Game', isWeb: false, next: 'https://game.cryptodoggies.io/'}]
      break
    case NFTTYPE.BARKING:
      exchangeToken = [
        SUPPORTTYPE.BARK
      ]
      getToken = ' Barking NFT'
      myUrl = '/myArtwork/bark'
      urls = [{title: 'Marketplace', isWeb: true, next: '/exchange/barkingnft'}, {title: 'Website', isWeb: false, next: 'https://www.cryptodoggies.io/'}, {title: 'Buy $BARK', isWeb: true, next: '/swap?outputCurrency=0xb1528a7be5a96b77de5337988ba69029ca6e2c7a'}, {title: 'Play Game', isWeb: false, next: 'https://game.cryptodoggies.io/'}]
      break
    case NFTTYPE.EQUIPMENT:
      exchangeToken = [
        SUPPORTTYPE.DOGGY
      ]
      getToken = ' Doggy Equipment'
      myUrl = '/myArtwork/equipment'
      break
    case NFTTYPE.MATRIX:
      exchangeToken = [
        SUPPORTTYPE.RACA,
        SUPPORTTYPE.BUSD
      ]
      getToken = ' Matrix Plus Box NFT'
      myUrl = '/myArtwork/RACA'
      break
    case NFTTYPE.BAKEMUSKMIXER:
      exchangeToken = [
        SUPPORTTYPE.BAKE,
        SUPPORTTYPE.BNB
      ]
      getToken = ' Bake Musk Mixer'
      myUrl = '/myArtwork/RACA'
      break
    case NFTTYPE.MUSKUSMLAND:
      exchangeToken = [
        SUPPORTTYPE.BNB
      ]
      getToken = ' MPB Usm Land'
      myUrl = '/myArtwork/RACA'
      break
    case NFTTYPE.GAMEACE:
      exchangeToken = [
        SUPPORTTYPE.BNB
      ]
      getToken = ' GameAce'
      nftToken = getGaAddress(sushi)
      myUrl = '/myArtwork/toy'
      break
  }

  const emptyBtns: any[] = []
  const [btnList, setBtnList] = useState(emptyBtns)
  const bnbBalance = useBnbBalance()
  const soccerBalance = useSoccerBalance()
  const pokerBalance = usePokerBalance()
  const carBalance = useCarBalance()
  const doggyBalance = useDoggyBalance()
  const barkBalance = useBarkBalance()
  const racaBalance = useRacaBalance()
  const busdBalance = useBusdBalance()
  const bakeBalance = useBakeBalance()
  const getBtnList = useCallback(async () => {   
    // 获取币种动态价格
    if(type === NFTTYPE.MATRIX){
      const exchangeTokenAddress = exchangeToken.map((d:any) => {
        return userTokenAddress(sushi,d)
      })
      const tokenAmountArray = await matrixPlusBoxContractGetPayTokenPrices(masterContract, exchangeTokenAddress)
      const tokenAmountAry = exchangeToken.map((tokenName,i) => ({
        tokenName, 
        tokenAmount: new BigNumber(tokenAmountArray[i]).div(new BigNumber(10).pow(new BigNumber(userTokenDecimals(tokenName)))).toNumber()
      }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
      tokenAmountAryFormat = tokenAmountAry
    }
    let btnNew:Array<any> = []
    exchangeToken.map(async (d, index) => {
      let text
      let tokenAmount
      let tokenBalance
      let tokenFormat = d
      // let tokenFormat = d.substring(0, 1).toUpperCase() + d.substring(1).toLowerCase()
      switch (type) {
        case NFTTYPE.GIFTBOX:
          text = 'Buy with xx ' + tokenFormat
          tokenAmount = 0
          break
        case NFTTYPE.GAMEBOX:
          text = 'Burn 0.25 ' + tokenFormat + ' to get 1 '
          tokenAmount = 0.25
          break
        case NFTTYPE.DOGGIES:
          text = 'Spend 100,000 $' + tokenFormat + ' to get 1 Crypto Doggy NFT'
          tokenAmount = 100000
          break
        case NFTTYPE.BARKING:
          text = 'Spend 500,000 $' + tokenFormat + ' to get 1 Barking NFT'
          tokenAmount = 500000
          break
        case NFTTYPE.EQUIPMENT:
          text = 'Spend 100,000 $' + tokenFormat + ' to get 1 NFT'
          tokenAmount = 100000
          break
        case NFTTYPE.MATRIX:
          // eslint-disable-next-line array-callback-return
          tokenAmountAryFormat.map((obj:any) => {
            if(obj.tokenName === d){
              text = 'Spend ' + new BigNumber(obj.tokenAmount).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) + ' $' + tokenFormat + ' to get 1 MPB NFT'
              tokenAmount = obj.tokenAmount
            }
          })
          break
        case NFTTYPE.BAKEMUSKMIXER:
          text = d === SUPPORTTYPE.BNB 
                  ? 'Spend 0.08 $BNB to get 1 NFT (100%)'
                  : 'Burn 0.08 $BAKE for a chance (4%) to get 1 NFT'
          tokenAmount = 0.08
          break
        case NFTTYPE.MUSKUSMLAND:
          text = 'Spend 1 $BNB to get 1 NFT'
          tokenAmount = 1
          break
        case NFTTYPE.GAMEACE:
          text = 'Spend 1 $BNB to get 1 NFT'
          tokenAmount = 1
          break  
      }
      switch (d) {
        case SUPPORTTYPE.BNB:
          tokenBalance = bnbBalance
          break
        case SUPPORTTYPE.SOCCER:
          tokenBalance = soccerBalance
          break
        case SUPPORTTYPE.POKER:
          tokenBalance = pokerBalance
          break
        case SUPPORTTYPE.CAR:
          tokenBalance = carBalance
          break
        case SUPPORTTYPE.DOGGY:
          tokenBalance = doggyBalance
          break
        case SUPPORTTYPE.BARK:
          tokenBalance = barkBalance
          break
        case SUPPORTTYPE.RACA:
          tokenBalance = racaBalance
          break
        case SUPPORTTYPE.BUSD:
          tokenBalance = busdBalance
          break
        case SUPPORTTYPE.BAKE:
          tokenBalance = bakeBalance
          break
      }
      let tokenAddress = userTokenAddress(sushi, d)
      let tokenContract = getContract(ethereum as provider, tokenAddress)
      let allowance: any = account && await getAllowance(tokenContract, masterContract, account)
      let isAllowance = new BigNumber(allowance).toNumber()
      if(d === SUPPORTTYPE.BNB){
        isAllowance = 1
      }
      let isSoldOut = false

      // issoldout BAKEMUSKMIXER
      if(type === NFTTYPE.BAKEMUSKMIXER){
        if(d === SUPPORTTYPE.BAKE){
          const bakeCanBuyInfos = await getLockTokenInfos(masterContract, [tokenAddress])
          const bakeCanBuyInfo = bakeCanBuyInfos[0]
          const bakeCanBuyCount = bakeCanBuyInfo.limit * 1 - bakeCanBuyInfo.quantity * 1
          bakeCanBuyCount * 1 ? isSoldOut = false : isSoldOut = true
        }else if(d === SUPPORTTYPE.BNB){
          const bnbCanBuyInfos = await getPayTokenInfos(masterContract, ["0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE"])
          const bnbCanBuyInfo = bnbCanBuyInfos[0]
          const bnbCanBuyCount = bnbCanBuyInfo.limit * 1 - bnbCanBuyInfo.quantity * 1
          bnbCanBuyCount * 1 ? isSoldOut = false : isSoldOut = true
        }
      }

      // issoldout MUSKUSMLAND
      if(type === NFTTYPE.MUSKUSMLAND){
        const bnbCanBuyInfos = await getMuskUsmLandPayTokenInfos(masterContract, ["0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE"])
        const bnbCanBuyInfo = bnbCanBuyInfos[0]
        const bnbCanBuyCount = bnbCanBuyInfo.limit * 1 - bnbCanBuyInfo.quantity * 1
        bnbCanBuyCount * 1 ? isSoldOut = false : isSoldOut = true
      }

      if(type === NFTTYPE.GAMEACE){
        const bnbCanBuyInfos = await sellPayTokenInfo(masterContract, nftToken, ["0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE"])
        const bnbCanBuyInfo = bnbCanBuyInfos[0]
        const bnbCanBuyCount = bnbCanBuyInfo.limit * 1 - bnbCanBuyInfo.quantity * 1
        bnbCanBuyCount * 1 ? isSoldOut = false : isSoldOut = true
      }

      if([NFTTYPE.MUSKUSMLAND].includes(type)){
        const startBlock = await getStartBlock(masterContract)
        const endBlock = await getEndBlock(masterContract)
        setStartBlock(+startBlock)
        setEndBlock(+endBlock)
      }

      if([NFTTYPE.GAMEACE].includes(type)){
        const sellInfo = await getSellInfo(masterContract, nftToken)
        const startBlock = sellInfo.startBlock
        const endBlock = sellInfo.endBlock
        setStartBlock(+startBlock)
        setEndBlock(+endBlock)
      }

      let obj = {
        index: index,
        token: d,
        text: text,
        tokenBalance: tokenBalance,
        // tokenUnit: d.substring(0, 1).toUpperCase() + d.substring(1).toLowerCase(),
        tokenUnit: d,
        requestedApproval: false,
        tokenAddress: tokenAddress,
        tokenContract: tokenContract,
        isAllowance: isAllowance,
        pendingTx: false,
        tokenAmount: tokenAmount,
        isSoldOut: isSoldOut
      }
      btnNew.push(obj)
      if(btnNew.length === exchangeToken.length){
        // 加index排序
        btnNew = btnNew.sort(compare('index'))
        setBtnList(btnNew)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, account, doggyBalance, barkBalance, racaBalance, busdBalance, bakeBalance, bnbBalance, getStartBlock, getEndBlock])

  // 授权
  const handleApprove = useCallback(async (d: any) => {
    try {
      d.requestedApproval = true
      d.isAllowance = 0
      const txHash = await approve(d.tokenContract, masterContract, account)
      // user tx or didn't go thru
      if (!txHash) {
        d.requestedApproval = false
      }else {
        setTimeout(() => {
          d.requestedApproval = false
          d.isAllowance = 1
        }, 10000)
      }
    } catch (e) {
      console.log("----e-----", e)
      d.requestedApproval = false
      d.isAllowance = 0
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approve, masterContract, account])

  // 中奖弹框
  const [WinPrize] = useModal(
    <WinPrizeModal/>
  )
  
  // 未中奖弹框
  const [NotWinPrize] = useModal(
    <NotWinPrizeModal/>
  )

  // mint nft
  const { onSynthesis } = useSynthesis(type)
  const makeMyDish = useCallback(async (d: any, index:any, btnList:any) => {
    try {
      d.pendingTx = true
      let tokenIsBNB = false
      if(d.token === SUPPORTTYPE.BNB){
        tokenIsBNB = true
      }
      const txHash = await onSynthesis(d.tokenAmount, d.tokenAddress, tokenIsBNB)
      if(type === NFTTYPE.BAKEMUSKMIXER && d.token === SUPPORTTYPE.BAKE){
        const luckyTime = await userLuckyTime(masterContract, account)
        // 获取用户抽奖结果， 默认0 未抽奖。 1 成功， 2 失败
        const luckyResult = await userLuckyResult(masterContract, account, luckyTime)
        if(luckyResult * 1 === 1){
          WinPrize()
        }else if(luckyResult * 1 === 2){
          NotWinPrize()
        }
      }
      if(type === NFTTYPE.BAKEMUSKMIXER && d.token === SUPPORTTYPE.BNB){
        WinPrize()
      }
      // user tx or didn't go thru
      if (!txHash) {
        d.pendingTx = false
      }else {
        setTimeout(() => {
          d.pendingTx = false
        }, 10000)
      }
    } catch (e) {
      console.log("----e-----", e)
      d.pendingTx = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approve, masterContract, onSynthesis])

  // soldOut
  const [soldOut, setSoldOut] = useState(false)

  const getSoldOut = useCallback(async () => {
    try {
      // count默认设置有值
      let count = 1
      switch (type){
        case NFTTYPE.MATRIX:
          count = await matrixPlusBoxContractGetWaitingToMintLength(masterContract)
          break
        case NFTTYPE.EQUIPMENT:
          const ids = await doggyEquipmentGetEnableEquipmentIds(masterContract)
          count = ids.length
          break
      }
      count * 1 ? setSoldOut(false) : setSoldOut(true)
    } catch (e) {
      console.log("----e-----", e)
    }
  }, [masterContract, type])

  useEffect(() => {
    getSoldOut()
    getBtnList()
  }, [getBtnList, ethereum, account, getSoldOut])

  return (
    <FormWrapper>
      {
        boxContentTitle ? (
          <AttachRow marginBottom={8}>
            <Text fontSize={13} fontWeight={700}>
              {boxContentTitle}
            </Text>
            <Text
              fontSize={14}
              color={theme.bsText7}
              fontWeight={700}
              fontFamily={'Baloo Da'}
              style={{ marginLeft: 8 }}
            >
              {boxContentValue}
            </Text>
          </AttachRow>
        ) : false
      }
      {
        currentValueTitle ? (
          <AttachRow marginBottom={20}>
            <Text fontSize={13} fontWeight={700}>
              {currentValueTitle}
            </Text>
            <Text
              fontSize={14}
              color={theme.bsText7}
              fontWeight={700}
              fontFamily={'Baloo Da'}
              style={{ marginLeft: 8 }}
            >
              <ValueItem>
                {/* <Value decimals={8} value={bnbAmount} /> &nbsp;<span className="label">BNB</span> */}
              </ValueItem>
            </Text>
          </AttachRow>
        ) : false
      }

      {
        // 链接钱包
        !account ? (
          <ButtonLight height={40} onClick={toggleWalletModal}>
            Connect Wallet
          </ButtonLight>
        ) : (
          <>
            {
              curBlock < startBlock ? (
                <ButtonConfirmed
                  disabled={true}
                  altDisabledStyle={true}
                  height={32}
                  padding="0px 5px"
                  marginBottom="20px"
                  className="btn"
                  fontSize={14}
                >
                  #Blocks Left: {startBlock - curBlock}
                </ButtonConfirmed>
              ): curBlock >= endBlock && endBlock != 0 ? (
                <ButtonConfirmed
                  disabled={true}
                  altDisabledStyle={true}
                  height={32}
                  padding="0px 5px"
                  marginBottom="20px"
                  className="btn"
                  fontSize={14}
                >
                  Finished
                </ButtonConfirmed>
              ) :
              soldOut ? (
                <ButtonConfirmed
                  disabled={true}
                  altDisabledStyle={true}
                  height={32}
                  padding="0px 5px"
                  marginBottom="20px"
                  className="btn"
                  fontSize={14}
                >
                  Sold out
                </ButtonConfirmed>
              ) : (
                <AttachBtnRow>
                  {
                    btnList.length ? (
                      btnList.map((d, index) => {
                        return (
                          <ButtonInfo key={index} width={[
                            NFTTYPE.MATRIX, 
                            NFTTYPE.BAKEMUSKMIXER,
                            NFTTYPE.MUSKUSMLAND
                          ].includes(type) ? 200 : 186}>
                            {
                              d.isSoldOut ? (
                                <ButtonConfirmed
                                  key={index}
                                  height={32}
                                  padding="0px 5px"
                                  fontSize={14}
                                  className="btn"
                                  disabled={true}
                                  altDisabledStyle={true}
                                >Sold out</ButtonConfirmed>
                              ): !d.isAllowance ? (
                                <ButtonConfirmed
                                  key={index}
                                  height={32}
                                  padding="0px 5px"
                                  fontSize={14}
                                  className="btn"
                                  onClick={handleApprove.bind(null,d)}
                                  disabled={d.requestedApproval}
                                >
                                  {
                                    d.requestedApproval ? (
                                      <AutoRow gap="6px" justify="center">
                                        Approving <Loader stroke="white" />
                                      </AutoRow>
                                    ) : (
                                      'Approve ' + d.tokenUnit
                                    )
                                  }
                                </ButtonConfirmed>
                              ) : new BigNumber(d.tokenAmount).lte(d.tokenBalance) ? (
                                  <ButtonConfirmed
                                    key={index}
                                    minHeight={32}
                                    padding="0px 5px"
                                    fontSize={14}
                                    className="btn"
                                    onClick={makeMyDish.bind(null, d, index, btnList)}
                                    disabled={d.pendingTx}
                                  >
                                    {
                                      d.pendingTx ? (
                                        <AutoRow gap="6px" justify="center">
                                          Making <Loader stroke="white" />
                                        </AutoRow>
                                      ) : d.text
                                    }
                                  </ButtonConfirmed>
                                ) : (
                                  <ButtonConfirmed
                                    key={index}
                                    height={32}
                                    padding="0px 5px"
                                    fontSize={14}
                                    className="btn"
                                    disabled={true}
                                  >
                                    {
                                      'Insufficient ' + d.tokenUnit + ' balance'
                                    }
                                  </ButtonConfirmed>
                                )
                            }
                            <Row>
                              <Text fontSize={13} fontWeight={700}>
                                Balance:
                              </Text>
                              <Text
                                fontSize={14}
                                color={theme.bsText7}
                                fontWeight={700}
                                fontFamily={'Baloo Da'}
                                style={{ marginLeft: 8 }}
                              >
                                <ValueItem>
                                  <Value decimals={3} value={d.tokenBalance} /> &nbsp;<span className="label">{d.tokenUnit}</span>
                                </ValueItem>
                              </Text>
                            </Row>
                          </ButtonInfo>
                        )
                      })
                    ) : false
                  }
                </AttachBtnRow>
              )
            }
            {
              myUrl && <MyDishes to={myUrl}>My {getToken}{[NFTTYPE.EQUIPMENT].includes(type) ? '' : 's'}</MyDishes>
            }
            <AutoRow justify="space-between">
              {
                urls && urls.map((d, index) => {
                  return (
                    d.isWeb ?
                    <MyDishes
                      key={index}
                      to={d.next}
                      width="49%"
                    >
                      {d.title}
                    </MyDishes>
                    : <Website key={index} width="49%" href={d.next} target="_blank">{d.title}</Website>
                  )
                })
              }
            </AutoRow>
          </>
        )
      }
    </FormWrapper>
  )
}